const Images = {
    truckicon: require('./truckicon.png'),
    headphoneicon: require('./headphoneicon.png'),
    securityicon: require('./securityicon.png'),
    sendicon: require('./sendicon.png'),
    loginImage: require('./loginImage.jpg'),
    usericon: require('./usericon.png'),
    carticon: require('./carticon.png'),
    logo: require('./logo.png'),
    searchicon: require('./searchicon.png'),
    clearicon: require('./clearicon.png'),
    hamburgericon: require('./hamburgericon.png'),
    herobg: require('./herobg.png'),
    herobgleft: require('./herobgleft.png')
}

export default Images;